// summary view actions
export const RESERVATION_COUNT_CHANGED = 'RESERVATION_COUNT_CHANGED';
export const PROMOTED_SERVICE_RESERVATION_COUNT_CHANGED = 'PROMOTED_SERVICE_RESERVATION_COUNT_CHANGED';
export const HOURLY_PROMOTED_SERVICE_RESERVATION_CHANGED = 'HOURLY_PROMOTED_SERVICE_RESERVATION_CHANGED';
export const PROMOTED_SERVICE_RESERVATION_REMOVED = 'PROMOTED_SERVICE_RESERVATION_REMOVED';
